import { AlertsTranslations } from './zh';

export const alertsEn: AlertsTranslations = {
  // Page Title
  title: 'Alerts',
  
  // Status
  noAlerts: 'No alerts',
  abnormal: 'Abnormal',
};

